import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
//Limitless imports
import { OkCancelDialog } from "@limitless/portal";
import { useTranslation } from "@limitless/common/hooks";

const CorruptUserSessionDialog = ({ open, onClose }) => {
    const { t } = useTranslation();

    return (
        <OkCancelDialog title={t("Session Error")} okLabel={t("Close")} onOKClick={onClose} open={open}>
            <Typography color="textPrimary" gutterBottom>
                {t("Please logout and login again")}
            </Typography>
            <Typography color="textPrimary" gutterBottom>
                {t("This can happen if you have Limitless open in multiple browser tabs.")}
            </Typography>
            <Typography color="textPrimary">
                {t("If this message persists, please contact Limitless Support.")}
            </Typography>
        </OkCancelDialog>
    );
};

export default CorruptUserSessionDialog;

CorruptUserSessionDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};
